import jwtDecode from 'jwt-decode';
// routes
import { PATH_AUTH } from '../routes/paths';

// ----------------------------------------------------------------------

const isValidToken = (access) => {
  if (!access) {
    return false;
  }
  try {
    const decoded = jwtDecode(access);
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch (error) {
    return false;
  }
};

const getRefreshToken = () => localStorage.getItem('refresh');

const setSession = (access, refresh = null) => {
  if (access) {
    localStorage.setItem('access', access);

    if (refresh) {
      localStorage.setItem('refresh', refresh);
    }
  } else {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
  }
};

const clearSession = () => {
  localStorage.removeItem('access');
  localStorage.removeItem('refresh');
  window.location.href = PATH_AUTH.login;
};

// Identify the current user in PostHog using the email/name claims that the
// backend embeds in the access token. Lets us re-identify on every silent
// refresh without an extra /user/me/ call.
const identifyInPostHogFromAccess = (access) => {
  if (typeof window === 'undefined' || !window.posthog?.identify) return;
  if (!access) return;
  try {
    const decoded = jwtDecode(access);
    if (!decoded?.email) return;
    window.posthog.identify(decoded.email, {
      email: decoded.email,
      name: decoded.name,
      user_id: decoded.user_id,
    });
  } catch {
    // bad token, nothing to do
  }
};

export { isValidToken, setSession, getRefreshToken, clearSession, identifyInPostHogFromAccess };
